/* global initLoopBundle */
// UBB-293: Re-init Loop bundle after any cart drawer change — no page reload.
//
// Root cause: Loop renders the bundle card via initLoopBundle() on DOMContentLoaded. It then
// relies on MutationObservers on cart <form> elements to detect changes and reload the page.
// But Motto's CartDrawerItems replaces .drawer__inner innerHTML on every update, destroying
// those form elements — so Loop's observer never fires and the bundle card goes stale.
//
// Fix: (1) neutralise Loop's built-in observer-based reload; (2) listen to cart update
// events, clear the stale bundle card, and re-run initLoopBundle() with fresh cart data —
// replicating the clean DOMContentLoaded init conditions without a page reload.
//
// Why neutralise setupMutationLoop:
//   Loop's setupMutationLoop() observes ALL <form> elements on the page and calls
//   window.location.reload() when total cart quantity changes. Every re-init call creates a
//   fresh set of observers on the new forms Motto just rendered, so the next qty/remove
//   triggers another reload — undoing the fix. We replace it with a no-op on DOMContentLoaded
//   (after loop_bundle.js has loaded but BEFORE its async initLoopBundle reaches the
//   setupMutationLoop call — JS is single-threaded, so our synchronous override always wins
//   the race over the awaited network calls inside addExtraDetailsToBundleItemsLoop).
//
// Two cart events are handled (each covers a different cart update path):
//
//   cart:change         — Motto fires this after drawer qty/remove AND after PDP adds.
//                         SUPPRESSED for PDP adds (see __cartAddSyncInFlight below) so
//                         we don't reinit into stale DOM before renderContents() finishes.
//                         For qty/remove the drawer DOM is already updated by the time
//                         cart:change fires, so no suppression or defer is needed there.
//
//   cart:drawer-refreshed — custom event dispatched by external-cart-add-sync.js after it
//                         refreshes the drawer for ANY /cart/add.js call (PDP adds,
//                         Rebuy/upsell quick-add). Fires AFTER renderContents(), so no
//                         defer needed, and handles all add-to-cart reinit exclusively.
//
// Hotfix path (page reload on cart:change) is temporarily disabled while this proper fix
// is validated. Re-enable + remove the re-init if it proves unreliable (UBB-293).

// Cart PAGE: cart.js re-renders .js-contents on every AJAX qty/remove (e.g. removing Priority
// Processing), which empties Loop's LOOP_BUNDLE_CONTAINER_CLASS — and Loop's own reload observer is
// neutralised below. Reload while the cart still holds bundle lines so the bundle card re-renders
// server-side, matching the add path (a native form submit that already reloads /cart).
if (document.querySelector('.LOOP_BUNDLE_CONTAINER_CLASS')) {
  document.addEventListener('cart:change', (event) => {
    const items = event.detail?.cart?.items || [];
    if (items.some((item) => item.properties?._bundleId)) {
      window.location.reload();
    }
  });
}

(function loopBundleCartSync() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  // Neutralise Loop's built-in reload-on-quantity-change.
  // loop_bundle.js is deferred (runs before DOMContentLoaded, so setupMutationLoop is
  // already defined by the time this fires). The inline cart-drawer.liquid DOMContentLoaded
  // callback fires first and calls initLoopBundle(), which immediately awaits network calls
  // (addExtraDetailsToBundleItemsLoop) — our synchronous override below runs before
  // setupMutationLoop() is ever reached inside that async chain.
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.setupMutationLoop !== 'undefined') {
      window.setupMutationLoop = () => {};
    }
  });

  // In-flight guard — ensures only one initLoopBundle() runs at a time.
  // initLoopBundle is async (fetches from Loop's API). If a second cart event fires while
  // the first is still awaiting, both would call renderBundleItemsLoop() on resolve —
  // which prepends to the container — producing duplicate bundle cards.
  // Fix: queue the latest request; run one follow-up after the current call finishes.
  let reinitInFlight = false;
  let reinitQueued = false;
  let queuedCartItems = null;

  async function reinitLoop(cartItems) {
    if (reinitInFlight) {
      // Another initLoopBundle is in flight — save the latest data and bail.
      // The in-flight call will pick it up when it finishes.
      reinitQueued = true;
      queuedCartItems = cartItems;
      return;
    }

    reinitInFlight = true;

    try {
      // Update Loop's item list BEFORE calling initLoopBundle so renderBundleItemsLoop
      // uses current cart data.
      if (cartItems) window.Loop.bundleCartAllItems = cartItems;

      // Clear the stale bundle card — initLoopBundle prepends to the container, so it must
      // be empty to avoid duplicates (same clean-slate condition as DOMContentLoaded).
      const loopContainer = document.querySelector(
        '.LOOP_BUNDLE_DRAWER_CONTAINER_CLASS'
      );
      if (loopContainer) loopContainer.innerHTML = '';

      if (typeof initLoopBundle === 'function') {
        await initLoopBundle('LOOP_BUNDLE_DRAWER_CONTAINER_CLASS');
      }
    } finally {
      reinitInFlight = false;

      // If a newer reinit was requested while we were awaiting, run it now.
      if (reinitQueued) {
        reinitQueued = false;
        const items = queuedCartItems;
        queuedCartItems = null;
        reinitLoop(items);
      }
    }
  }

  // cart:change — covers qty/remove from the drawer.
  // Suppressed when __cartAddSyncInFlight is true (set by external-cart-add-sync.js before
  // Motto's handler receives the /cart/add.js response and fires cart:change). PDP adds and
  // Rebuy quick-adds are handled exclusively by cart:drawer-refreshed below, which fires
  // after a full drawer refresh — reiniting here too would cause a double-render into stale
  // DOM and produce the flash / duplicate-bundle symptoms.
  document.addEventListener('cart:change', (event) => {
    if (window.__cartAddSyncInFlight) return;
    reinitLoop(event.detail?.cart?.items);
  });

  // cart:drawer-refreshed — covers Rebuy/upsell adds (external-cart-add-sync.js).
  // DOM is already updated when this fires, so no defer needed.
  document.addEventListener('cart:drawer-refreshed', (event) => {
    reinitLoop(event.detail?.cart?.items);
  });

  // ─── Hotfix path (temporarily disabled — re-init above is the active fix) ────────────────
  // Uncomment to re-enable page-reload fallback; delete entirely once re-init is confirmed.
  // document.addEventListener('cart:change', () => {
  //   if (cartDrawer.dataset.ppForceRefresh === 'true') window.location.reload();
  // });
})();
